(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gl-home-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const slides = Array.from(root.querySelectorAll('[data-gl-slide]'));
    if (slides.length < 2) return;
    const status = root.querySelector('[data-gl-status]');
    let index = 0;
    let timer;
    let startX = null;
    let startY = null;
    let swiped = false;
    const stop = () => { clearInterval(timer); timer = null; };
    const show = (next, manual) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      if (manual) status.textContent = slides[index].querySelector('h2').textContent;
    };
    const start = () => {
      stop();
      if (!document.hidden) {
        timer = setInterval(() => show(index + 1, false), Number(root.dataset.delay) || 8000);
      }
    };
    const move = direction => { show(index + direction, true); start(); };
    root.querySelector('[data-gl-prev]').addEventListener('click', () => move(-1));
    root.querySelector('[data-gl-next]').addEventListener('click', () => move(1));
    document.addEventListener('visibilitychange', start);
    root.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse') return;
      startX = event.clientX; startY = event.clientY; swiped = false;
    });
    root.addEventListener('pointerup', event => {
      if (startX === null) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      startX = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { swiped = true; move(dx < 0 ? 1 : -1); }
    });
    root.addEventListener('pointercancel', () => { startX = null; });
    root.addEventListener('click', event => {
      if (swiped) { event.preventDefault(); swiped = false; }
    }, true);
    start();
  };
  const scan = () => document.querySelectorAll('[data-gl-home-slider]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-product-recommendations"]) return;
  try {
    
function glAlignRecommendations(root) {
  root.querySelectorAll('[data-product-recommendations]').forEach(container => {
    if (container.dataset.glRowAlignment) return;
    container.dataset.glRowAlignment = 'true';
    let frame;
    let width = container.clientWidth;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!container.isConnected) return;
        const row = container.querySelector('[data-product-row]');
        if (!row) return;
        const cards = [...row.querySelectorAll('.productgrid--item')];
        const slider = row.querySelector('.flickity-slider');
        const viewport = row.querySelector('.flickity-viewport');
        cards.forEach(card => card.style.height = 'auto');
        row.style.height = '';
        if (slider) slider.style.height = 'auto';
        if (viewport) viewport.style.height = 'auto';
        const visible = cards.filter(card => getComputedStyle(card).display !== 'none');
        const height = Math.ceil(Math.max(0, ...visible.map(card => card.getBoundingClientRect().height)));
        if (!height) return;
        visible.forEach(card => card.style.height = height + 'px');
        if (slider && viewport) {
          slider.style.height = height + 'px';
          viewport.style.height = height + 'px';
          row.style.height = height + 'px';
        }
      });
    };
    const observer = new MutationObserver(align);
    observer.observe(container, {childList:true,subtree:true,characterData:true});
    const resize = new ResizeObserver(() => {
      if (container.clientWidth !== width) { width = container.clientWidth; align(); }
    });
    resize.observe(container);
    container.addEventListener('load', align, true);
    container.addEventListener('rimg:load', align);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      container.removeEventListener('load', align, true);
      container.removeEventListener('rimg:load', align);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    align();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => glAlignRecommendations(document), {once:true});
} else {
  glAlignRecommendations(document);
}
document.addEventListener('shopify:section:load', event => glAlignRecommendations(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-recently-viewed"]) return;
  try {
    
function glAlignRecentCards(root) {
  root.querySelectorAll('[data-recently-viewed-container]').forEach(container => {
    if (container.dataset.glCardAlignment) return;
    container.dataset.glCardAlignment = 'true';
    let frame;
    let width = container.clientWidth;
    const align = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!container.isConnected) return;
        const cards = [...container.querySelectorAll('.product-recently-viewed-card')];
        cards.forEach(card => card.style.height = 'auto');
        const height = Math.ceil(Math.max(0, ...cards.map(card => card.getBoundingClientRect().height)));
        cards.forEach(card => card.style.height = height + 'px');
        container.dispatchEvent(new CustomEvent('rimg:load'));
      });
    };
    const observer = new MutationObserver(align);
    observer.observe(container, {childList:true, subtree:true, characterData:true});
    const resize = new ResizeObserver(() => {
      if (container.clientWidth !== width) {
        width = container.clientWidth;
        align();
      }
    });
    resize.observe(container);
    container.addEventListener('load', align, true);
    const unload = event => {
      if (!event.target.contains(container)) return;
      observer.disconnect();
      resize.disconnect();
      cancelAnimationFrame(frame);
      container.removeEventListener('load', align, true);
      document.removeEventListener('shopify:section:unload', unload);
    };
    document.addEventListener('shopify:section:unload', unload);
    align();
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => glAlignRecentCards(document), {once:true});
} else {
  glAlignRecentCards(document);
}
document.addEventListener('shopify:section:load', event => glAlignRecentCards(event.target));

  } catch(e) { console.error(e); }
})();
})();
